import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-84b7f24c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "label bodyBase"
};
import { computed, useSlots } from "vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        modelValue: { type: [String, Number, Boolean, Object, Array], default: "" },
        options: { default: () => [] },
        placeholder: { default: "请选择" },
        disabled: { type: Boolean, default: false },
        label: { default: "" },
        valueKey: { default: "" },
        clearable: { type: Boolean, default: false },
        filterable: { type: Boolean, default: false }
    },
    emits: ["update:modelValue", "change"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const selectVal = computed({
            get() {
                return props.modelValue;
            },
            set(val) {
                emits("update:modelValue", val);
            }
        });
        const selectChange = (val) => {
            emits("change", val);
        };
        return (_ctx, _cache) => {
            const _component_el_option = _resolveComponent("el-option");
            const _component_el_select = _resolveComponent("el-select");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['cloud-select-container', __props.label ? 'has-label' : ''])
            }, [
                (__props.label)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.label), 1))
                    : _createCommentVNode("", true),
                _createVNode(_component_el_select, {
                    modelValue: _unref(selectVal),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(selectVal) ? (selectVal).value = $event : null)),
                    "popper-class": {
                        'has-slot-header': useSlots().header
                    },
                    class: "w-100",
                    placeholder: __props.placeholder,
                    "value-key": __props.valueKey,
                    disabled: __props.disabled,
                    clearable: __props.clearable,
                    filterable: __props.filterable,
                    onChange: selectChange
                }, {
                    default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "header"),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                            }, {
                                default: _withCtx(() => [
                                    _renderSlot(_ctx.$slots, "option", { data: item })
                                ]),
                                _: 2
                            }, 1032, ["label", "value"]));
                        }), 128))
                    ]),
                    _: 3
                }, 8, ["modelValue", "popper-class", "placeholder", "value-key", "disabled", "clearable", "filterable"])
            ], 2));
        };
    }
});
